module.exports = __webpack_public_path__ + "static/img/icon-p3.aafa2650.png";